import { Component, Input, OnInit } from '@angular/core';
import { HumanInteractionService } from '../../../../services/human-interaction.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-totals-per-agreements-modal',
  templateUrl: './totals-per-agreements-modal.component.html',
  styleUrls: ['./totals-per-agreements-modal.component.css']
})
export class TotalsPerAgreementsModalComponent implements OnInit {

  @Input() modalTitle: string;
  error = '';
  objInitialState: any;
  data: any[];
  hasColor: boolean;

  constructor(
    private humanInteractionService: HumanInteractionService,
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.hasColor = this.objInitialState.hasColors;
    this.objInitialState.filter.stateLifeCycles = [8, 7, 11];
    this.humanInteractionService.getTotalsPerAgreementItems(this.objInitialState.filter)
      .subscribe( result => {
        this.data = result;
      });
  }

  onClose() {
    this.bsModalRef.hide();
  }

  transformTime(seconds: number) {
    if (seconds >= 3600) {
      const minutes = Math.trunc((seconds % 3600) / 60);
      const hours = Math.trunc(seconds / 3600);
      if (minutes === 0) { return `${hours}h`; } else { return `${hours}h${minutes}min`; }
    } else if (seconds >= 120) {
      return `${Math.trunc(seconds / 60)} minutos`;
    } else {
      return `${seconds} segundos`;
    }
  }

}
